import { space } from '@repo/theme/primitives';
import { observer } from 'mobx-react-lite';
import HorizontalResizeHandle from '../HorizontalResizeHandle';
import {
	COLLAPSED_NAV_SIDEBAR_WIDTH,
	EXPANDED_NAV_MAX_SIDEBAR_WIDTH,
	EXPANDED_NAV_MIN_SIDEBAR_WIDTH,
	NAV_SIDEBAR_TRIGGER_WIDTH,
	SIDEBAR_COLOR,
} from './constants';
import { sideBarStore } from './SideBar/store';

interface ResizeSideBarProps {
	className?: string;
}

function ResizeSideBar({ className }: ResizeSideBarProps) {
	const handleResize = (updatedWidth: number) => {
		const { collapsed } = sideBarStore;

		if (
			(collapsed && updatedWidth >= NAV_SIDEBAR_TRIGGER_WIDTH) ||
			(!collapsed && updatedWidth < NAV_SIDEBAR_TRIGGER_WIDTH)
		) {
			sideBarStore.setCollapsed(!collapsed);
		}

		if (
			!collapsed &&
			updatedWidth >= EXPANDED_NAV_MIN_SIDEBAR_WIDTH &&
			updatedWidth <= EXPANDED_NAV_MAX_SIDEBAR_WIDTH
		) {
			sideBarStore.setWidth(updatedWidth);
		}
	};

	const handleDoubleClick = () => {
		sideBarStore.toggle();
	};

	return (
		<HorizontalResizeHandle
			handleSize={space[3]}
			minWidth={COLLAPSED_NAV_SIDEBAR_WIDTH}
			maxWidth={EXPANDED_NAV_MAX_SIDEBAR_WIDTH}
			backgroundColor={SIDEBAR_COLOR}
			onResize={handleResize}
			className={className}
			onDoubleClick={handleDoubleClick}
		/>
	);
}

const ObservedResizeSideBar = observer(ResizeSideBar);
export default ObservedResizeSideBar;
